/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=0229bdd2&scoped=true&"
import script from "./Replace.vue?vue&type=script&lang=js&"
export * from "./Replace.vue?vue&type=script&lang=js&"
import style0 from "./Replace.vue?vue&type=style&index=0&id=0229bdd2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229bdd2",
  null
  
)

export default component.exports